exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".filter-accordion{border-radius:6px !important;margin-top:0em;margin-bottom:1em;border:none !important}.filter-accordion #filter-header{font-weight:bold}.filter-accordion .MuiFormLabel-root,.filter-accordion .makeStyles-labelRoot-30,.filter-accordion .MuiSelect-select,.filter-accordion .MuiInput-input{font-size:13.5px}.filter-sub-title{font-weight:bold}.errorMessageStyle{color:#f44336;font-size:.74rem;text-align:left;font-family:\"Assistant\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400;line-height:1.66;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ActivityCenter/SubComponents/CaseFilters.scss
// module id = 1668
// module chunks = 101